import { Box, Skeleton, Card } from '@mui/material';
import { FC } from 'react';
import LayoutWithSidebar from '../../common/layoutWithSidebar';
import theme from '../../../theme';

export const CallsPageSkeleton: FC = () => {
  return (
    <LayoutWithSidebar margin={2}>
      <Box
        sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <Box
          sx={{
            border: `1px solid ${theme.palette.lightGray.main}`,
            borderRadius: '12px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton width={80} height={20} />
              <Skeleton width={150} height={40} />
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Skeleton width={140} height={40} />
              <Skeleton width={140} height={40} />
              <Skeleton width={150} height={40} />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: '100%',
            border: `1px solid ${theme.palette.lightGray.main}`,
            borderRadius: '12px',
            padding: '16px',
          }}
        >
          <Box sx={{ display: 'flex', gap: 3 }}>
            {[1, 2, 3].map(index => (
              <Box key={index} sx={{ flex: 1 }}>
                <Card sx={{ p: 3, borderRadius: 2 }}>
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={40}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton variant="text" width="40%" height={20} />
                </Card>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </LayoutWithSidebar>
  );
};
